import { Opt } from 'app/tools/general.types';
import { LSKey } from 'app/tools/hooks/local-storage/local-storage.types';
import useLocalState from 'app/tools/hooks/local-storage/use-local-storage';
import React, { useCallback, useContext } from 'react';

export type InstructionsState = {
  scanInstructions: boolean;
  cameraErrors: boolean;
  cameraPermissions: boolean;
  welcomeAddProduct: boolean;
};

type InstructionsHook = [
  instructions: InstructionsState,
  updateInstructionsStatus: (
    update: Partial<InstructionsState>
  ) => unknown
];
const InstructionsContext =
  React.createContext<Opt<InstructionsHook>>(undefined);

type Props = {
  children: React.ReactNode;
};

export function InstructionsProvider({
  children,
}: Props): JSX.Element {
  const [instructions, setInstructions] = useLocalState(
    LSKey.INSTRUCTIONS_STATUS,
    {
      scanInstructions: true,
      cameraErrors: true,
      cameraPermissions: true,
      welcomeAddProduct: true,
    }
  );

  const updateInstructionsStatus = useCallback(
    (update: Partial<InstructionsState>) =>
      setInstructions(s => ({ ...s, ...update })),
    [setInstructions]
  );

  return (
    <InstructionsContext.Provider
      value={[instructions, updateInstructionsStatus]}
    >
      {children}
    </InstructionsContext.Provider>
  );
}

export const useInstructions = (): InstructionsHook => {
  const instructionsHook = useContext(InstructionsContext);
  if (instructionsHook === undefined) {
    throw new Error(
      'useInstructions can only be used inside its provider'
    );
  }
  return instructionsHook;
};
